var _style, _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlaceholder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 164 126",
    style: {
      enableBackground: "new 0 0 164 126"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#0F447C;}\n\t.st2{fill-rule:evenodd;clipRule:evenodd;fill:#1D3B6C;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 57.5,
    y: 38.7,
    className: "st0",
    width: 48,
    height: 48
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    width: 164,
    height: 126
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M35.1,71.7c11.6,4.4,19.2,11.7,19.2,11.7c0.1-3.5,1-7.2,2.3-10.3c0,0-3.7-6.9-14.6-14.3 C30.4,50.8,17,48.5,17,48.5c-2.7,5.9-4.7,12.2-5.7,18.9C11.3,67.4,21.1,66.3,35.1,71.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M43.5,48.4c11,10.6,15,21.3,15,21.3c2-3.3,4.8-6.1,8-8.2c0,0-4.1-12.8-10.7-22.3c-6.6-9.5-17.4-17.3-17.4-17.3 c-5.3,4-9.9,8.8-13.9,14.1C24.4,36,35.4,40.7,43.5,48.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M128.9,71.7c-11.6,4.4-19.2,11.7-19.2,11.7c-0.1-3.5-1-7.2-2.3-10.3c0,0,3.7-6.9,14.6-14.3 c11.7-8,25.1-10.2,25.1-10.2c2.7,5.9,4.7,12.2,5.7,18.9C152.7,67.4,142.9,66.3,128.9,71.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M120.5,48.4c-11,10.6-15,21.3-15,21.3c-2-3.3-4.8-6.1-8-8.2c0,0,4.1-12.8,10.7-22.3 c6.6-9.5,17.4-17.3,17.4-17.3c5.3,4,9.9,8.8,13.9,14.1C139.6,36,128.6,40.7,120.5,48.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M62.9,35.2c5,12.7,6.3,24.7,6.3,24.7c3.3-1.7,7.5-3,11.4-3.4c0,0,0.2-12.2-2.5-24.8C74.9,17,71.3,7.9,71.3,7.9 c-6.5,1-12.8,2.9-18.6,5.5C52.6,13.4,59.4,26.4,62.9,35.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M101.1,35.2c-5,12.7-6.3,24.7-6.3,24.7c-3.3-1.7-7.5-3-11.4-3.4c0,0-0.2-12.2,2.5-24.8 C89.1,17,92.7,7.9,92.7,7.9c6.5,1,12.8,2.9,18.6,5.5C111.4,13.4,104.6,26.4,101.1,35.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M44.8,114.9c13.8-6.5,27.7-5.2,27.7-5.2c-4.9-1.8-9.2-5-12.4-9c0,0-12.4-1.5-21.8,0.4 c-14.3,2.9-20.7,7.8-20.7,7.8c2.9,6,6.6,11.4,11,16.3C28.6,125.2,34.6,119.7,44.8,114.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M34,94.2c14.1-0.7,23.8,3,23.8,3c-1.7-3.1-2.9-6.6-3.3-10.3c0,0-11.2-6.3-21.5-7.7 c-14.3-1.9-22.6,0.8-22.6,0.8c0.2,6.7,1.3,13.2,3.2,19.3C13.7,99.3,22.9,94.7,34,94.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M82,125.6c20.1,0,28.9,17.3,28.9,17.3c6.3-2.8,12.1-6.4,17.2-10.7c0,0-17-21.3-46.2-21.3 c-29.2,0-46.2,21.3-46.2,21.3c5.2,4.3,11,8,17.2,10.7C53.1,142.9,61.9,125.6,82,125.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M119.3,114.9c-13.8-6.5-27.7-5.2-27.7-5.2c4.9-1.8,9.2-5,12.4-9c0,0,12.4-1.5,21.8,0.4 c14.3,2.9,20.7,7.8,20.7,7.8c-2.9,6-6.6,11.4-11,16.3C135.4,125.2,129.4,119.7,119.3,114.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M130,94.2c-14.1-0.7-23.8,3-23.8,3c1.7-3.1,2.9-6.6,3.3-10.3c0,0,11.2-6.3,21.5-7.7 c14.3-1.9,22.6,0.8,22.6,0.8c-0.2,6.7-1.3,13.2-3.2,19.3C150.3,99.3,141.1,94.7,130,94.2z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholder);
export default __webpack_public_path__ + "static/media/placeholder.23a40ea89ab7bb7f92f617789281c7af.svg";
export { ForwardRef as ReactComponent };